import { Settings, Info } from "lucide-react";

export default function GuestSettings() {
  return (
    <div className="space-y-4" data-testid="guest-settings">
      <div className="bg-white border border-slate-200 rounded-2xl p-6">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-xl bg-hocp-navy text-white flex items-center justify-center shrink-0">
            <Settings className="w-4 h-4"/>
          </div>
          <div>
            <h3 className="font-display text-[16px] font-semibold text-hocp-navy">Guest OS Settings</h3>
            <p className="text-[13px] text-slate-500 mt-1">
              Capabilities (<span className="mono">guest.view</span>, <span className="mono">guest.create</span>, <span className="mono">guest.edit</span>, <span className="mono">guest.blacklist</span>, <span className="mono">guest.stay.manage</span>, <span className="mono">guest.loyalty.adjust</span>, <span className="mono">guest.complaint.manage</span>, <span className="mono">guest.company.manage</span>) are managed via Workforce OS permission bundles. Three starter bundles are seeded: <span className="mono">guest_reader</span>, <span className="mono">guest_agent</span>, <span className="mono">guest_manager</span>.
            </p>
          </div>
        </div>
      </div>
      <div className="bg-sky-50/50 border border-sky-200 rounded-2xl p-4 flex items-start gap-3">
        <Info className="w-4 h-4 text-sky-600 mt-0.5 shrink-0"/>
        <div className="text-[12.5px] text-sky-900">
          <div className="font-semibold">Integration recipe for module developers</div>
          <div className="mt-1">
            Any module can enrich a guest via <span className="mono bg-white px-1.5 py-0.5 rounded">POST /api/guest/v1/guests/{"{"}id{"}"}/*</span> endpoints (stays, documents, communications, complaints). Every enrichment automatically appears in the guest&apos;s Timeline and Ops Hub events. Reservations, Finance folios and F&amp;B orders should carry <span className="mono bg-white px-1.5 py-0.5 rounded">guest_id</span> so the master profile aggregates spend and activity across every touchpoint.
          </div>
        </div>
      </div>
    </div>
  );
}
